import React, { Component } from 'react';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import config from '../../config';
import { HTMLTrans } from '../Common/Translations';
import FrontendRedirectPaths from '../Common/Helpers/FrontendRedirectPaths';

const { pathname } = window.location;

export const getQueryStringParam = () => queryString.parse(window.location.search);

export const getQueryParamsAndReappend = (params) => {
  const queryParams = getQueryStringParam();

  if ('file' in queryParams) {
    params += `&file=${queryParams.file}`;
  }
  return params;
};

const getStoreInfoApi = storeCode => $.get(`${config.localeApi}/store/info/${storeCode}`);

class Ribbon extends Component {
  state = {
    choiceSelected: false,
    ribbonHide: false,
    referStore: {},
    store: {}
  };

  constructor(props) {
    super(props);
    this.getReferrerStoreInfo();
    this.getStoreInfo();
  }

  componentDidMount() {
    const { referrer } = getQueryStringParam();

    if (referrer) {
      const url = new URL(window.location);
      window.history.pushState({}, '', url);
    }
  }

  handleCheckboxChange = () => {
    this.setState({
      choiceSelected: !this.state.choiceSelected
    });
  };

  handleRibbonClose = () => {
    this.setState({
      ribbonHide: true
    });
    Cookies.set('storeReferrer', 'true', { expires: 10 * 365 });
  }

  getReferrerStoreInfo = () => {
    const { referrer } = getQueryStringParam();

    getStoreInfoApi(referrer)
      .done((response) => {
        this.setState({ referStore: response.data });
      });
  }

  getStoreInfo = () => {
    getStoreInfoApi(config.storeCode)
      .done((response) => {
        this.setState({ store: response.data });
      });
  }

  handleReturnOriginalStore = () => {
    let urlParams = '?storeReferrerChoice=1';
    urlParams = getQueryParamsAndReappend(urlParams);

    if (this.state.choiceSelected) {
      urlParams += '&storeReferrerChoiceRemember=1';
    }

    window.location.replace(this.state.referStore.url + pathname + urlParams);
  }

  renderRibbonText() {
    const { referStore, store: thisStore } = this.state;

    return (
      <div className="col-12 col-xl-auto mb-1 mb-xl-0">
        <HTMLTrans id="ribbon.welcome_text" variables={{ 'store': thisStore.name, 'storeRefer': referStore.name }}>
          Welcome to {thisStore.name}! Would you like to go back to
          <span className="ProximaNova-Bold"> {referStore.name}?</span>
        </HTMLTrans>
      </div>
    );
  }

  renderRibbonCheckbox() {
    return (
      <div className="col-auto d-flex">
        <div className="pr-3">
          <a onClick={this.handleReturnOriginalStore}
             className="btn-sm btn-white py-1">
            <b className="ProximaNova-Bold text-primary">
              <HTMLTrans id="ribbon.choice_yes">YES</HTMLTrans>
            </b>
          </a>
        </div>
        <div className="">
          <label className="custom-control custom-checkbox m-0">
            <input type="checkbox" className="custom-control-input"
                   onChange={this.handleCheckboxChange}/>
            <span className="custom-control-indicator"></span>
            <span className="custom-control-description">
              <HTMLTrans id="ribbon.choice_remember">Remember my choice</HTMLTrans>
            </span>
          </label>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="bg-primary" style={{ display: this.state.ribbonHide ? 'none' : 'block' }}>
        <div className="container">
          <div className="row py-2">
            <div className="col d-flex align-items-center">
              <div className="row">
                {this.renderRibbonText()}
                {this.renderRibbonCheckbox()}
              </div>
              <div className="ml-auto">
                <button className="close text-white" onClick={this.handleRibbonClose}>×</button>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="d-flex">
            <div className="row">
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const willShowOnRecommend = (WrappedComponent) => {
  class willShow extends Component {
    constructor(props){
      super(props);
      this.state = {applicablePathnames: []};
    }

    componentDidMount() {
      FrontendRedirectPaths().then((res) => {
        this.setState({applicablePathnames: res});
      });
    }

    render() {
      const storeReferrerCookie = Cookies.get('storeReferrer');
      const { referrer } = getQueryStringParam();

      if (!this.state.applicablePathnames.includes(pathname)) {
        return null;
      }
      if (referrer && !(storeReferrerCookie)) {
        return (
          <WrappedComponent/>
        );
      }
      return null;
    }
  }
  return willShow;
};

export const undecorated = Ribbon;



// WEBPACK FOOTER //
// ./src/Ribbon/Ribbon.js